import { RangeValue } from '@cad-arc';
import { subHours } from 'date-fns';
import { NonCustomTimeRangeValue, TimeRangeValue } from './types';

export function timeRangeToHours(timeRange: TimeRangeValue): number {
    switch (timeRange) {
        case 'LAST_12_HOURS':
            return 12;
        case 'LAST_16_HOURS':
            return 16;
        case 'LAST_24_HOURS':
            return 24;
        case 'LAST_36_HOURS':
            return 36;
        case 'LAST_48_HOURS':
            return 48;
        default:
            return 36;
    }
}

export function timeRangeValueToDateRange(
    timeRangeValue: NonCustomTimeRangeValue
): RangeValue<string> {
    return {
        start: subHours(new Date(), timeRangeToHours(timeRangeValue)).toISOString(),
        end: new Date().toISOString(),
    };
}
